<template>
  <div v-if="user && !user.activated" class="bg-danger text-center p-2">
    メールアドレスの認証が完了していません。ご登録のメールアドレス宛にお送りしているメールを確認し、認証を完了してください。
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    user: 'auth/user'
  }),

  data() {
    return {
      
    }
  },
  
  mounted() {
      //
  },

  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Notice.vue